import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Button.less';
import MaterialIcon from './MaterialIcon';

export function Button({
  children,
  type,
  variant,
  width,
  onClick,
  loading,
  disabled,
  className,
  id,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      style={{ width }}
      className={classNames(styles.container, className, {
        [styles.primary]: variant === 'primary',
        [styles.secondary]: variant === 'secondary',
        [styles.tertiary]: variant === 'tertiary',
      })}
      disabled={disabled || loading}
      id={id}
    >
      {children}
      {loading && (
        <div className={styles.loading}>
          <MaterialIcon icon="progress_activity" spin />
        </div>
      )}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  width: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
